import * as preact from "preact";

import { cn } from "shared/utils";
import type { VoiceOption } from "tts";
import * as ttsUi from "views/ttsUi";

type VoiceRowVariant = "picker" | "upsell";

const classForVariant = (variant: VoiceRowVariant, suffix: string): string =>
  variant === "upsell" ? `ttsUpsellVoice${suffix}` : `ttsVoice${suffix}`;

export const TTSVoiceRow = ({
  voice,
  selected = false,
  locked = false,
  onSelect,
  onPreview,
  variant = "picker",
}: {
  voice: VoiceOption;
  selected?: boolean;
  locked?: boolean;
  onSelect?: () => void;
  onPreview?: () => void;
  variant?: VoiceRowVariant;
}): preact.JSX.Element => {
  const genderLabel = voice.gender
    ? ttsUi.capitalizeGender(voice.gender)
    : null;

  return (
    <li
      class={cn({
        [classForVariant(variant, "Row")]: true,
        selected,
        locked,
      })}
      onClick={() => {
        if (locked) return;
        onSelect?.();
      }}
    >
      <span class={classForVariant(variant, "Name")}>{voice.displayName}</span>
      {genderLabel ? (
        <span class={classForVariant(variant, "Meta")}>{genderLabel}</span>
      ) : null}
      {voice.tag ? (
        <span class={classForVariant(variant, "Tag")}>{voice.tag}</span>
      ) : null}
      <span class={classForVariant(variant, "Spacer")}></span>
      {locked ? (
        <span class="ttsVoiceLock" title="Requires upgrade">
          <i class="icon-lock"></i>
        </span>
      ) : onPreview ? (
        <button
          class={variant === "upsell" ? "ttsUpsellPlay" : "ttsVoicePlay"}
          title="Preview"
          onClick={(event) => {
            event.stopPropagation();
            onPreview();
          }}
        >
          {ttsUi.playIcon()}
        </button>
      ) : null}
    </li>
  );
};

export const TTSRateSelector = ({
  rate,
  onPickRate,
  disabled = false,
}: {
  rate: number;
  onPickRate: (rate: number) => void;
  disabled?: boolean;
}): preact.JSX.Element => (
  <div class="ttsRateRow">
    <span class="ttsRateLabel">Rate:</span>
    {ttsUi.RATE_CHOICES.map((choice) => (
      <span
        class={cn({
          ttsRateOption: true,
          selected: choice === rate,
          disabled,
        })}
        onClick={() => {
          if (!disabled) onPickRate(choice);
        }}
      >
        {choice}x
      </span>
    ))}
  </div>
);
